import * as O from 'fp-ts/lib/Option';

import { CardHtml } from './CardHtml';
import { StudyStat } from './StudyStat';

export interface StepProgress {
  total: number;
  done: number;
}

export interface NextStepProgress {
  Main: StepProgress;
  Survey: StepProgress;
  Review: StepProgress;
}

export interface NextStep {
  c: O.Option<CardHtml>;
  s: StudyStat;
  msg?: string;
  mode: string;
  streak?: number;
  progress: NextStepProgress;
}

export const zeroStepProgress: StepProgress = { total: 0, done: 0 };
